import React from 'react';
import { Radio as MUIRadio, RadioGroup, FormControlLabel } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useQuestion from './useQuestion';
import Markdown from '../../markdown';

const useStyles = makeStyles((theme) => {
    return {
        readOnly: {
            '& p[readonly].MuiTypography-root': {
                color: '#3C3E45',
                opacity: 1,
            },
        },
    };
});

const Radio = (props) => {
    const { question, disabled, readOnly } = props;

    const { chosenVal, setChosenVal } = useQuestion(question);

    const classes = useStyles();

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <RadioGroup
            value={chosenVal?.[0] ? chosenVal[0] : null}
            onChange={(event) => setChosenVal([event.target.value])}
            disabled={disabled}
            className={readOnly ? classes.readOnly : null}
        >
            {question?.options?.map((opt, i) => {
                return (
                    <FormControlLabel
                        key={`question-${question.id}`}
                        value={opt.id}
                        control={<MUIRadio />}
                        label={
                            opt?.text?.['en-US'] ? (
                                <Markdown
                                    readOnly={readOnly}
                                    children={opt.text['en-US']}
                                />
                            ) : (
                                ''
                            )
                        }
                        disabled={disabled || readOnly}
                    />
                );
            })}
        </RadioGroup>
    );
};

export default Radio;
